exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clanblack[data-v-5b6e6172]{font-family:ClanFFBlack!important;font-weight:400}.clanpro[data-v-5b6e6172]{font-family:ClanPro!important;font-weight:400}.clanprobold[data-v-5b6e6172],.ibox-content dl dd[data-v-5b6e6172]{font-family:ClanProBold!important;font-weight:400}.clanprobook[data-v-5b6e6172]{font-family:ClanProBook!important;font-weight:400}.ibox a[data-v-5b6e6172]{color:#000}.ibox a[data-v-5b6e6172]:hover{color:#1aae7c}.ibox-content[data-v-5b6e6172]{font-size:12px}.ibox-content dl[data-v-5b6e6172],.ibox-content dl dt[data-v-5b6e6172]{margin-bottom:0}.ibox-content dl dd[data-v-5b6e6172]{clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b6e6172","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Exports.vue
// module id = 727
// module chunks = 0